.left-section {
    display: flex;
    background-color: var(--plum-lt);
}

.referral-iframe {
    height: 40px;
}
